import type { CardHooks } from "./registry";
import { safeNum } from "@/lib/utils";

/**
 * "This is Sparta" — defend prompt:
 * When played as defend, ask the player to exhaust up to 2 weapons for +2 block each.
 * On attack: stun→power-bonus is now data-driven via on_attack_damage mechanic; do NOT
 * hardcode here.
 */
export const thisIsSparta: CardHooks = {
  onDefendPlay: (ctx) => {
    const { self, card } = ctx;
    const weaponSlots = self.equipSlots
      .map((slot, slotIdx) => ({ slot, slotIdx }))
      .filter(({ slot }) => slot.cardId && !slot.tapped)
      .map(({ slot, slotIdx }) => ({
        slotIdx,
        cardId: slot.cardId as string,
        name: "Weapon", // engine can resolve real name when prompt is rendered
      }));

    const baseBlock = safeNum(card.attackDefendFields?.blockValue ?? 0);

    return {
      prompt: {
        kind: "sparta-defend",
        playerNum: self.num,
        playCardId: `${card.id}_${Date.now()}`,
        playCardDbId: card.id,
        baseBlock,
        // +2 block per weapon exhausted (matches defendAbility text).
        extraBlockBonus: 2,
        weaponSlots,
        selected: [],
      },
      log: [`${card.name} — choose up to 2 weapons to exhaust for +2 block each`],
    };
  },
};
